import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert, Glyphicon, PanelGroup, Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import { withTranslation, Trans } from 'react-i18next';
import moment from 'moment';
import 'icheck/skins/minimal/grey.css';	// used for styling booking options accordion
import 'react-block-ui/style.css';
import utils from '../../common/services/utils';
import ui from '../../common/services/ui';

class IndividualConsultationBookingOptions extends Component {
	constructor(props) {
		super(props);
	}

	componentWillReceiveProps(nextProps) {
		// trigger Confirm after child is selected and props are updated
		if (!this.props.bookingOptions.selectedChildId && nextProps.bookingOptions.selectedChildId) {
			this.props.onConfirm();
		}
	}

	handleBookingSelect(childId) {
		if (this.props.bookingOptions.selectedChildId) {
			this.props.onConfirm();
		} else {
			this.props.onSelectChild(childId);
		}
	}

	renderChildrenInfo() {
		const { children, bookingOptions: { selectedChildId }, t } = this.props;
		if (!children)
			return null;

		let displayChildren = children;
		if (selectedChildId) {
			displayChildren = children.filter(c => c.id === selectedChildId);
		}

		return <div>
			{displayChildren.map(child => {
				const name = child.shortName;
				const isFirstConsultation = !child.hasIndividualConsultation;
				const consultationDisplayName = t(isFirstConsultation ? 'IndividualConsultationType_Assessment' : 'IndividualConsultationType_Consultation');

				return (
					<div key={child.id} style={{ marginBottom: '20px' }} className='suitable-classes'>
						<Trans i18nKey='FO_Booking_Class_IndividualConsultationForChild'>
							Select time slot to book <b style={{ color: '#1d93d1' }}>{{ consultationDisplayName }}</b> for <b style={{ color: '#1d93d1' }}>{{ name }}</b>
						</Trans>
					</div>
				);
			})}
		</div>;
	}

	renderChildBookingOptions(child, center, date, t) {
		const isInIframe = window.self !== window.top;

		return <div key={child.id} style={{ marginBottom: '10px' }}>
			{child.id > 0 ? <p><Glyphicon glyph='user' /> {child.shortName}</p> : null}
			<PanelGroup id={`booking_${child.id}`}>
				<Panel className='booking-option'>
					<Panel.Heading className='checked'>
						<Panel.Title>
							{this.renderPaymentOptionContent(child, center, t)}
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body>
						{isInIframe ? <Link target='_top' className='btn-block btn btn-primary' to={`/public/individual-consultations/${center.id}/book/${date}`}>{t('FO_Booking_IndividualConsultation_Select')} <i className='fa fa-arrow-circle-right' /></Link>:
							<Button className='btn-block btn btn-primary' onClick={() => this.handleBookingSelect(child.id)}>
							{t('FO_Booking_IndividualConsultation_Select')} <i className='fa fa-arrow-circle-right' />
						</Button>}
					</Panel.Body>
				</Panel>
			</PanelGroup>
		</div>;
	}

	renderPaymentOptionContent(child, center, t) {
		const { currentCurrency, franchisorCurrency, enableCurrencyConversion } = this.props;

		const isFirstConsultation = !child.hasIndividualConsultation;
		const consultationDisplayName = t(isFirstConsultation ? 'IndividualConsultationType_Assessment' : 'IndividualConsultationType_Consultation');
		const consultationPrice = isFirstConsultation ? center.individualConsultationFirstPrice : center.individualConsultationPrice;
		const consultationTotal = isFirstConsultation ? center.individualConsultationFirstTotal : center.individualConsultationTotal;
		const consultationPriceAmount = isFirstConsultation ? center.individualConsultationFirstPriceAmount : center.individualConsultationPriceAmount;
		const conversionLink = ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, consultationPriceAmount);

		return <div>
			<div className='payment-type'>
				<span style={{ float: 'left' }}>{consultationDisplayName}</span>
				<div className='clearfix' />
			</div>
			<div className='price'>
				<span style={{ float: 'left', fontSize: '14px' }}>{`1 x ${consultationPrice}`}</span>
				<span style={{ float: 'right' }}>{consultationTotal}</span>
				<div className='clearfix' />
				{conversionLink &&
					<a href={conversionLink} target='_blank' className='currency-conversion' style={{ float: 'right' }}>{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a>}
				<div className='clearfix' />
			</div>
		</div>;
	}

	renderBookingOptions() {
		const { t, bookingOptions: { date, selectedChildId }, children, center, enableUserTimeZone } = this.props;

		let errorMessage = null;
		const scheduleItemStartTime = moment(date).utcOffset(center.utcOffset, true);	// actual start time using center's timezone
		if (scheduleItemStartTime < new Date()) {
			errorMessage = t('FO_Booking_Validation_LessonStarted');
		}

		if (errorMessage) {
			return <Alert bsStyle="danger" >
				<div className='suitable-classes' dangerouslySetInnerHTML={{ __html: errorMessage }} />
			</Alert>;
		}

		const selectedChild = selectedChildId && children.find(c => c.id === selectedChildId);
		const visibleChildren = selectedChild ? [selectedChild] : [...children];
		if (visibleChildren.length === 0) {
			visibleChildren.push({ id: -1, shortName: '', hasIndividualConsultation: false });
		}

		const consultationDuration = selectedChild && selectedChild.hasIndividualConsultation ? center.individualConsultationDuration : center.individualConsultationFirstDuration;
		const consultationStartMoment = enableUserTimeZone ? utils.convertToUserTime(date, center) : moment(date);
		const consultationEndMoment = moment(consultationStartMoment).add(consultationDuration, 'hours');

		return <div>
			<p><Glyphicon glyph='calendar' /> {consultationStartMoment.format('ll, dddd')}</p>
			<p><Glyphicon glyph='time' /> {consultationStartMoment.format('LT')} - {consultationEndMoment.format('LT')}</p>
			<p><CenterDetailsLink center={center} /></p>

			{visibleChildren.map(x => this.renderChildBookingOptions(x, center, date, t))}
		</div>;
	}

	render() {
		const { bookingOptions: { date }, onCancel, t } = this.props;

		return <div>
			<h3>{t('FO_Booking_BookingOptions_Title')}{date && <a className='pull-right' style={{ top: '5px', cursor: 'pointer' }} onClick={onCancel}><FontAwesome name='times' /></a>}</h3>

			{!date && this.renderChildrenInfo()}

			{date && this.renderBookingOptions()}
		</div>;
	}
}

IndividualConsultationBookingOptions.propTypes = {
	bookingOptions: PropTypes.shape({
		errorMessage: PropTypes.string,
		date: PropTypes.string,
		selectedChildId: PropTypes.number
	}),
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string,
		hasIndividualConsultation: PropTypes.boolean
	})),
	center: PropTypes.shape({
		name: PropTypes.string,
		address: PropTypes.string,
		addressDescription: PropTypes.string,
		phoneNumber: PropTypes.string,
		additionalInfo: PropTypes.string,
		latitude: PropTypes.number,
		longitude: PropTypes.number,
		individualConsultationFirstPrice: PropTypes.string,
		individualConsultationPrice: PropTypes.string
	}),
	enableUserTimeZone: PropTypes.bool,
	onSelectChild: PropTypes.func,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(IndividualConsultationBookingOptions);